import { generateUtilityClasses } from '@mui/material';

export const popoverContentClasses = generateUtilityClasses('PopoverContent', ['root']);
